import { useCallback, useEffect, useRef, useState } from 'react';

export function useCopyToClipboard(resetDelay = 1800) {
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  useEffect(() => () => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
  }, []);

  const copy = useCallback(
    async (text: string, id: string) => {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const helper = document.createElement('textarea');
          helper.value = text;
          helper.setAttribute('readonly', 'readonly');
          helper.style.position = 'fixed';
          helper.style.top = '-1000px';
          helper.style.opacity = '0';
          document.body.appendChild(helper);
          helper.select();
          document.execCommand('copy');
          document.body.removeChild(helper);
        }
        setCopiedId(id);
        if (timerRef.current) {
          window.clearTimeout(timerRef.current);
        }
        timerRef.current = window.setTimeout(() => setCopiedId(null), resetDelay);
        return true;
      } catch {
        setCopiedId(null);
        return false;
      }
    },
    [resetDelay],
  );

  return { copiedId, copy };
}